/* BioBeauty theme · sin dependencias. Todo funciona sin JS; esto solo lo mejora. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {} };
  var routes = theme.routes;
  var lastFocus = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- Drawers (menú, carrito) ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.classList.add('no-scroll');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = d.querySelector('[data-drawer-close].icon-btn, a[href], button, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
    return true;
  }

  function closeDrawer(d) {
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { d.hidden = true; }, 250);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && theme.cartType !== 'drawer') return;
      if (openDrawer(opener.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }

    var fOpen = e.target.closest('[data-filters-open]');
    if (fOpen) { var f = $('[data-filters]'); if (f) { f.classList.add('is-open'); document.documentElement.classList.add('no-scroll'); } return; }
    var fClose = e.target.closest('[data-filters-close]');
    if (fClose) { var ff = $('[data-filters]'); if (ff) { ff.classList.remove('is-open'); document.documentElement.classList.remove('no-scroll'); } }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-drawer]').forEach(function (d) { if (!d.hidden) closeDrawer(d); });
    var f = $('[data-filters].is-open');
    if (f) { f.classList.remove('is-open'); document.documentElement.classList.remove('no-scroll'); }
  });

  /* ---------- Barra de anuncios (rota en móvil) ---------- */
  var ann = $('[data-announcement]');
  if (ann) {
    var items = $$('.announcement__item', ann);
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        if (window.innerWidth >= 750) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    }
  }

  /* ---------- Carrito ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', Number(n) === 0);
    });
  }

  function renderCart(html) {
    if (!html) return;
    var fresh = parse(html).querySelector('[data-cart-inner]');
    var current = $('[data-cart-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      setCount(fresh.dataset.count || 0);
    }
  }

  function showError(container, msg) {
    var el = container && container.querySelector('[data-form-error], [data-bundle-error]');
    if (!el) { window.alert(msg); return; }
    el.textContent = msg;
    el.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]') || theme.cartType !== 'drawer' || !$('#CartDrawer')) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          showError(form, res.data.description || res.data.message || 'No pudimos agregar el producto.');
          return;
        }
        if (res.data.sections) renderCart(res.data.sections['cart-drawer']);
        trackAdd([res.data]);
        openDrawer('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  function changeLine(line, qty) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty)), sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-qty]');
    if (!b) return;
    e.preventDefault();
    var line = b.closest('.cart-line');
    if (line) line.classList.add('is-loading');
    changeLine(b.dataset.cartQty, b.dataset.qty).then(function (data) {
      if ($('[data-cart-page]')) { window.location.reload(); return; }
      if (data.sections) renderCart(data.sections['cart-drawer']);
      else setCount(data.item_count);
    }).catch(function () { window.location.reload(); });
  });

  /* ---------- Cantidad en ficha ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* ---------- Variantes ---------- */
  document.addEventListener('change', function (e) {
    var picker = e.target.closest('[data-variant-picker]');
    if (!picker) return;
    var section = picker.closest('[data-product-section]');
    var json = picker.querySelector('[data-variants-json]');
    if (!section || !json) return;
    var variants = JSON.parse(json.textContent);

    var selected = $$('[data-option]', picker).map(function (fs) {
      var c = fs.querySelector('input:checked');
      var label = fs.querySelector('[data-option-value]');
      if (c && label) label.textContent = c.value;
      return c ? c.value : null;
    });
    var variant = variants.find(function (v) {
      return v.options.every(function (o, idx) { return o === selected[idx]; });
    });

    var addBtn = section.querySelector('[data-add-button]');
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'No disponible'; }
      return;
    }

    $$('[data-variant-id]', section).forEach(function (input) { input.value = variant.id; });
    var url = section.dataset.url + '?variant=' + variant.id;
    window.history.replaceState({}, '', url);

    if (variant.featured_media) {
      var slide = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      var track = section.querySelector('[data-gallery]');
      if (slide && track) {
        if (window.innerWidth >= 990) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        else track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    fetch(url + '&section_id=' + section.dataset.sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        ['[data-price]', '[data-buy-state]', '[data-sticky-price]', '[data-highlights]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var old = section.querySelector(sel);
          if (fresh && old) old.replaceWith(fresh);
        });
        var sb = section.querySelector('[data-sticky-button]');
        if (sb) sb.disabled = !variant.available;
      });
  });

  /* ---------- Galería: miniaturas activas ---------- */
  $$('[data-gallery]').forEach(function (track) {
    var thumbs = $$('[data-thumb]', track.closest('.product__gallery'));
    if (!thumbs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.id;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('href') === '#' + id); });
      });
    }, { root: track, threshold: 0.6 });
    $$('.gallery__slide', track).forEach(function (s) { io.observe(s); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        var target = document.getElementById(t.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
    });
  });

  /* ---------- Barra fija de compra (móvil) ---------- */
  var sticky = $('[data-sticky-buy]');
  var mainBuy = $('[data-buy-state]');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      sticky.classList.toggle('is-visible', !visible);
      document.body.classList.toggle('has-sticky-buy', !visible);
    }).observe(mainBuy);
  }

  /* ---------- Pestañas ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('[role="tab"]', wrap);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = tabs[(idx + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(next);
        next.focus();
      });
    });
  });

  /* ---------- Filtros y orden ---------- */
  function submitFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
    var sort = $('[data-sort]');
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    window.location.href = form.getAttribute('action') + '?' + params.toString() + '#productos';
  }
  var debounce;
  document.addEventListener('change', function (e) {
    var sortSel = e.target.closest('[data-sort]');
    if (sortSel) {
      var form = $('[data-facets]');
      if (form) { submitFacets(form); return; }
      var p = new URLSearchParams(window.location.search);
      p.set('sort_by', sortSel.value);
      window.location.search = p.toString();
      return;
    }
    var facets = e.target.closest('[data-facets]');
    if (!facets || window.innerWidth < 990) return;
    clearTimeout(debounce);
    var wait = e.target.matches('[data-debounce]') ? 700 : 0;
    debounce = setTimeout(function () { submitFacets(facets); }, wait);
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-facets]')) return;
    e.preventDefault();
    submitFacets(e.target);
  });

  /* ---------- Cargar más ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-load-more]');
    if (!a) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true');
    fetch(a.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parse(html);
      var grid = $('[data-product-grid]');
      var items = doc.querySelectorAll('[data-product-grid] > li');
      items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
      var wrap = $('[data-load-more-wrap]');
      var freshWrap = doc.querySelector('[data-load-more-wrap]');
      if (wrap) { if (freshWrap) wrap.replaceWith(freshWrap); else wrap.remove(); }
      window.history.replaceState({}, '', a.href);
    }).catch(function () { window.location.href = a.href; });
  });

  /* ---------- Analítica: Klaviyo, GTM / GA4 y apps de terceros ---------- */
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CLP';
  var fmt = new Intl.NumberFormat('es-CL', { style: 'currency', currency: currency, maximumFractionDigits: currency === 'CLP' ? 0 : 2 });
  function trackAdd(items) {
    try {
      var list = (items || []).reduce(function (acc, it) { return acc.concat(it && it.items ? it.items : [it]); }, []).filter(Boolean);
      if (!list.length) return;
      var value = list.reduce(function (s, it) { return s + (it.final_line_price || it.price * it.quantity || 0); }, 0) / 100;
      // Evento propio para cualquier app o script
      document.dispatchEvent(new CustomEvent('bb:cart:added', { detail: { items: list, value: value, currency: currency } }));
      // Google Tag Manager / GA4
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: currency,
          value: value,
          items: list.map(function (it) { return { item_id: String(it.sku || it.variant_id), item_name: it.product_title, item_brand: it.vendor, item_variant: it.variant_title, price: it.price / 100, quantity: it.quantity }; })
        }
      });
      // Klaviyo (si su app está activa)
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        list.forEach(function (it) {
          window.klaviyo.push(['track', 'Added to Cart', {
            $value: it.price / 100 * it.quantity,
            AddedItemProductName: it.product_title,
            AddedItemProductID: it.product_id,
            AddedItemSKU: it.sku,
            AddedItemImageURL: it.image,
            AddedItemURL: window.location.origin + it.url,
            AddedItemPrice: it.price / 100,
            AddedItemQuantity: it.quantity
          }]);
        });
      }
    } catch (err) { /* la analítica nunca debe romper la compra */ }
  }

  /* ---------- Cuenta regresiva (barra superior y hero de campaña) ---------- */
  function parseEnd(str, tz) {
    if (!str) return null;
    var s = String(str).trim().replace(' ', 'T');
    if (!/(Z|[+-]\d{2}:?\d{2})$/.test(s)) s += (tz && /^[+-]\d{2}:\d{2}$/.test(tz.trim()) ? tz.trim() : '-03:00');
    var d = new Date(s);
    return isNaN(d) ? null : d;
  }
  $$('[data-countdown]').forEach(function (el) {
    var end = parseEnd(el.dataset.countdown, el.dataset.tz);
    if (!end) return;
    var parts = { d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'), m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]') };
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    var timer;
    function tick() {
      var diff = Math.floor((end - new Date()) / 1000);
      if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
      el.hidden = false;
      if (parts.d) parts.d.textContent = pad(Math.floor(diff / 86400));
      if (parts.h) parts.h.textContent = pad(Math.floor(diff % 86400 / 3600));
      if (parts.m) parts.m.textContent = pad(Math.floor(diff % 3600 / 60));
      if (parts.s) parts.s.textContent = pad(diff % 60);
    }
    timer = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Carruseles de productos y reseñas ---------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (wrap) {
      if (wrap.dataset.carouselReady) return;
      wrap.dataset.carouselReady = '1';
      function track() {
        var panel = wrap.matches('[data-tabs]') ? $('.tab-panel:not([hidden]) [data-carousel-track]', wrap) : null;
        return panel || wrap.querySelector('[data-carousel-track]');
      }
      function update() {
        var t = track();
        if (!t) return;
        var prev = wrap.querySelector('[data-carousel-prev]');
        var next = wrap.querySelector('[data-carousel-next]');
        if (prev) prev.disabled = t.scrollLeft < 8;
        if (next) next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 8;
      }
      wrap.addEventListener('click', function (e) {
        var dir = e.target.closest('[data-carousel-next]') ? 1 : e.target.closest('[data-carousel-prev]') ? -1 : 0;
        if (!dir) return;
        var t = track();
        if (t) t.scrollBy({ left: dir * t.clientWidth * 0.85, behavior: 'smooth' });
      });
      $$('[data-carousel-track]', wrap).forEach(function (t) { t.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true }); });
      window.addEventListener('resize', update);
      update();
    });
  }
  initCarousels(document);

  /* ---------- Banner deslizable ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dots = $$('[data-slider-dot]', slider);
    if (slides.length < 2) return;
    var index = 0, timer = null;
    var delay = Number(slider.dataset.speed) || 6000;
    function go(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      index = Math.max(0, Math.min(slides.length - 1, i));
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); d.setAttribute('aria-current', k === index ? 'true' : 'false'); });
    }
    function play() {
      if (slider.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    slider.addEventListener('click', function (e) {
      if (e.target.closest('[data-slider-next]')) { go(index + 1); play(); }
      else if (e.target.closest('[data-slider-prev]')) { go(index - 1); play(); }
      else if (e.target.closest('[data-slider-dot]')) { go(Number(e.target.closest('[data-slider-dot]').dataset.sliderDot)); play(); }
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', play);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    play();
  });

  /* ---------- Fecha estimada de llegada ---------- */
  $$('[data-delivery]').forEach(function (el) {
    var cutoff = Number(el.dataset.cutoff) || 14;
    var dayFmt = new Intl.DateTimeFormat('es-CL', { weekday: 'short', day: 'numeric', month: 'short' });
    function addBusiness(from, n) {
      var d = new Date(from);
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    }
    var start = new Date();
    if (start.getHours() >= cutoff || start.getDay() === 0 || start.getDay() === 6) {
      start = addBusiness(start, 1);
    }
    function range(attr, target) {
      var parts = (el.dataset[attr] || '').split(',').map(Number);
      var out = el.querySelector(target);
      if (!out || parts.length < 2) return;
      out.textContent = 'llega entre el ' + dayFmt.format(addBusiness(start, parts[0])) + ' y el ' + dayFmt.format(addBusiness(start, parts[1]));
    }
    range('rm', '[data-delivery-rm]');
    range('reg', '[data-delivery-reg]');
  });

  /* ---------- Recomendaciones (carga diferida, con respaldo) ---------- */
  function loadRecs(el, url, isFallback) {
    var mainTpl = el.querySelector('template[data-bundle-main]');
    var mainHtml = mainTpl ? mainTpl.innerHTML : (el._bundleMain || '');
    el._bundleMain = mainHtml;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = parse(html).querySelector('[data-recommendations-url]');
      var content = fresh ? fresh.innerHTML.trim() : '';
      if (!content || content.indexOf('data-bundle') === -1 && content.indexOf('card') === -1) {
        if (!isFallback && el.dataset.fallbackUrl) loadRecs(el, el.dataset.fallbackUrl, true);
        return;
      }
      el.innerHTML = content;
      var list = el.querySelector('[data-bundle-list]');
      if (list && mainHtml) list.insertAdjacentHTML('afterbegin', mainHtml);
      initBundles(el);
      initCarousels(el);
    });
  }
  $$('[data-recommendations-url]').forEach(function (el) {
    var start = function () { loadRecs(el, el.dataset.recommendationsUrl, false); };
    if (!('IntersectionObserver' in window)) { start(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      start();
    }, { rootMargin: '400px 0px' });
    io.observe(el);
  });

  /* ---------- Comprados juntos habitualmente ---------- */
  function initBundles(root) {
    $$('[data-bundle]', root).forEach(function (b) {
      var total = b.querySelector('[data-bundle-total]');
      var btn = b.querySelector('[data-bundle-add]');
      function update() {
        var sum = 0, n = 0;
        $$('[data-bundle-id]', b).forEach(function (c) { if (c.checked) { sum += Number(c.dataset.bundlePrice); n++; } });
        total.textContent = fmt.format(sum / 100);
        btn.disabled = n === 0;
      }
      b.addEventListener('change', update);
      update();
      btn.addEventListener('click', function () {
        var mainVariant = $('[data-product-section] [data-variant-id]');
        var items = $$('[data-bundle-id]', b).filter(function (c) { return c.checked; }).map(function (c) {
          var id = c.hasAttribute('data-bundle-main-input') && mainVariant ? mainVariant.value : c.dataset.bundleId;
          return { id: Number(id), quantity: 1 };
        });
        if (!items.length) return;
        btn.disabled = true;
        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) { showError(b, res.data.description || 'No pudimos agregar los productos.'); return; }
            trackAdd([res.data]);
            if (theme.cartType === 'drawer' && res.data.sections) { renderCart(res.data.sections['cart-drawer']); openDrawer('CartDrawer'); }
            else window.location.href = routes.cart;
          })
          .finally(function () { btn.disabled = false; });
      });
    });
  }
  initBundles(document);

  /* ---------- Video de YouTube liviano (carga al hacer clic) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-youtube]');
    if (!btn) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(btn.dataset.youtube) + '?autoplay=1&rel=0';
    iframe.title = btn.getAttribute('aria-label') || 'Video';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    btn.replaceWith(iframe);
  });

  /* ---------- Footer: columnas plegables en móvil ---------- */
  if (window.innerWidth < 750) $$('.footer__details').forEach(function (d) { d.open = false; });

  /* ---------- Descripción de marca: «Leer más» ---------- */
  $$('[data-clamp]').forEach(function (el) {
    var btn = el.parentElement.querySelector('[data-clamp-toggle]');
    if (!btn || el.scrollHeight <= el.clientHeight + 4) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.textContent = open ? 'Leer menos' : 'Leer más';
    });
  });


  /* ---------- Videos de la comunidad ---------- */
  $$('[data-svideos]').forEach(function (wrap) {
    var videos = $$('video', wrap);
    if (!videos.length) return;
    var auto = wrap.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    videos.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.removeAttribute('controls'); });
    if (auto && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && en.intersectionRatio >= 0.6) { if (v.preload === 'none') v.preload = 'auto'; play(v); }
          else if (!v.paused) v.pause();
        });
      }, { threshold: [0, 0.6] });
      videos.forEach(function (v) { io.observe(v); });
    }
    wrap.addEventListener('click', function (e) {
      var sound = e.target.closest('[data-svideo-sound]');
      var toggle = e.target.closest('[data-svideo-toggle]');
      if (!sound && !toggle) return;
      var card = e.target.closest('.svideo');
      var v = card && card.querySelector('video');
      if (!v) return;
      if (sound) {
        var willUnmute = v.muted;
        videos.forEach(function (o) {
          o.muted = true;
          var b = o.closest('.svideo').querySelector('[data-svideo-sound]');
          if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Activar sonido'); }
        });
        v.muted = !willUnmute;
        sound.setAttribute('aria-pressed', willUnmute ? 'true' : 'false');
        sound.setAttribute('aria-label', willUnmute ? 'Silenciar' : 'Activar sonido');
        if (willUnmute) play(v);
      } else {
        if (v.paused) play(v); else v.pause();
      }
    });
    videos.forEach(function (v) {
      v.addEventListener('play', function () { v.closest('.svideo').classList.add('is-playing'); });
      v.addEventListener('pause', function () { v.closest('.svideo').classList.remove('is-playing'); });
    });
  });


  /* ---------- Visor de imágenes del producto (ampliar y hacer zoom) ---------- */
  $$('[data-lightbox]').forEach(function (lb) {
    var section = lb.closest('[data-product-section]') || document;
    var track = lb.querySelector('[data-lightbox-track]');
    var slides = Array.prototype.slice.call(track.children);
    var counter = lb.querySelector('[data-lightbox-count]');
    var index = 0;
    if (typeof lb.showModal !== 'function') return; // sin soporte: el enlace abre la imagen grande

    function load(i) {
      var img = slides[i] && slides[i].querySelector('img[data-src]');
      if (!img) return;
      img.srcset = img.dataset.srcset || '';
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
    function unzoom() {
      lb.classList.remove('is-zoomed');
      $$('[data-zoomer].is-zoomed', lb).forEach(function (z) { z.classList.remove('is-zoomed'); z.scrollTo(0, 0); });
    }
    function update() {
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      var prev = lb.querySelector('[data-lightbox-prev]');
      var next = lb.querySelector('[data-lightbox-next]');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function go(i, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      unzoom();
      load(index); load(index + 1); load(index - 1);
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      update();
    }
    function release() { document.documentElement.classList.remove('no-scroll'); }
    function close() { unzoom(); if (lb.open) lb.close(); release(); }

    section.addEventListener('click', function (e) {
      var a = e.target.closest('[data-zoom]');
      if (!a) return;
      e.preventDefault();
      lb.showModal();
      document.documentElement.classList.add('no-scroll');
      var i = Number(a.dataset.zoom) || 0;
      load(i);
      requestAnimationFrame(function () { go(i, false); });
    });
    lb.addEventListener('close', release);
    lb.addEventListener('cancel', function () { unzoom(); release(); });

    var settle;
    track.addEventListener('scroll', function () {
      if (lb.classList.contains('is-zoomed')) return;
      clearTimeout(settle);
      settle = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && slides[i]) { index = i; load(i); load(i + 1); load(i - 1); update(); }
      }, 140);
    }, { passive: true });

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-lightbox-close]')) { close(); return; }
      if (e.target.closest('[data-lightbox-prev]')) { go(index - 1, true); return; }
      if (e.target.closest('[data-lightbox-next]')) { go(index + 1, true); return; }
      var z = e.target.closest('[data-zoomer]');
      if (z) {
        var img = z.querySelector('img');
        if (!img) return;
        if (z.classList.contains('is-zoomed')) { unzoom(); return; }
        var r = img.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) { close(); return; }
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        z.classList.add('is-zoomed');
        lb.classList.add('is-zoomed');
        void z.offsetWidth; // fuerza el nuevo tamaño antes de posicionar
        z.scrollLeft = Math.max(0, px * z.scrollWidth - z.clientWidth / 2);
        z.scrollTop = Math.max(0, py * z.scrollHeight - z.clientHeight / 2);
        return;
      }
      if (e.target === lb || e.target === track || e.target.classList.contains('lightbox__slide')) close();
    });

    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
    });

    // Arrastrar con el mouse para recorrer la imagen ampliada (en celular se usa el dedo)
    $$('[data-zoomer]', lb).forEach(function (z) {
      var drag = null;
      z.addEventListener('mousedown', function (e) {
        if (!z.classList.contains('is-zoomed')) return;
        drag = { x: e.clientX, y: e.clientY, l: z.scrollLeft, t: z.scrollTop, moved: false };
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 4) drag.moved = true;
        z.scrollLeft = drag.l - dx;
        z.scrollTop = drag.t - dy;
      });
      window.addEventListener('mouseup', function () {
        if (drag && drag.moved) { z.addEventListener('click', function stop(ev) { ev.stopPropagation(); z.removeEventListener('click', stop, true); }, true); }
        drag = null;
      });
    });
  });

  /* ---------- Formularios de dirección: país por defecto ---------- */
  $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });

  /* ---------- Editor de temas: reabrir drawers/pestañas al editar ---------- */
  document.addEventListener('shopify:block:select', function (e) {
    var tab = document.getElementById('Tab-' + (e.detail && e.detail.blockId));
    if (tab) tab.click();
  });
})();
